module.exports = __webpack_public_path__ + "img/lens-150-plus-06.f31eff6a.png";